import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "primeicons/primeicons.css";

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4">
      <Container fluid>
        <Row className="justify-content-between">
          <Col lg={6} className="">
            <div
              className="map-container"
              style={{
                height: "250px",
                width: "100%",
                alignContent: "justify-content-space-between",
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18890.38310545193!2d-113.2108844!3d53.7129555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53a047aabd35efdf%3A0xa914438fffdec172!2sShawn&#39;s%20barbershop!5e0!3m2!1sen!2slb!4v1722423417468!5m2!1sen!2slb"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </Col>
          <Col className="">
            <h5>Contact Us</h5>
            <p>
              <i className="pi pi-phone"></i> Phone: +1 780 589 1115 <br />
              <i className="pi pi-envelope"></i> Email:
              info@shawnsbarbershop.com <br />
              <i className="pi pi-map-marker"></i> Address: 123 Barber Street,
              Fort Saskatchewan, AB
            </p>
            <h5>Follow Us</h5>
            <p>
              <a
                href="https://facebook.com"
                className="text-white me-3"
                target="_blank"
              >
                <i className="pi pi-facebook"></i>
              </a>
              <a
                href="https://twitter.com"
                className="text-white me-3"
                target="_blank"
              >
                <i className="pi pi-twitter"></i>
              </a>
              <a
                href="https://instagram.com"
                className="text-white me-3"
                target="_blank"
              >
                <i className="pi pi-instagram"></i>
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
